export default [
    {
        path: '/emcadmin/plans/charge-types',
        name: 'emcadmin-plans-charge-types',
        component: () => import ('./views/ChargeTypeIndex'),
        meta: {
            title: 'Tipos de cobrança',
            icon: 'mdi-account-credit-card',
            breadcrumbs: [
                { text: 'Descrição da rota', disabled: true }
            ]
        }
    },
]
